<template>
  <div v-if="userDetails != null">
    <div class="mb-4 border-b border-gray-200 dark:border-gray-700">
    <ul class="flex flex-wrap -mb-px" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
        <li class="mr-2" role="presentation">
            <button @click="selectedTab = 1" class="inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300" :class="selectedTab === 1 ? 'active' : ''" id="profile-tab" data-tabs-target="#profile" type="button" role="tab" aria-controls="profile" :aria-selected="selectedTab === 1 ? true : false">Overall</button>
        </li>
        <li class="mr-2" role="presentation">
            <button @click="selectedTab = 2" class="inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300" :class="selectedTab === 2 ? 'active' : ''" id="settings-tab" data-tabs-target="#settings" type="button" role="tab" aria-controls="settings" :aria-selected="selectedTab === 2 ? true : false">Usage</button>
        </li>
    </ul>
    </div>
    <div id="myTabContent">
        <div class="p-4 bg-white rounded-lg dark:bg-gray-800" :class="selectedTab === 1 ? '' : 'hidden'" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="md:h-full md:w-full pl-2 pr-2 mb-4">
              <div class="block p-6 bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                  <span class="block mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Credits Overall</span>
                  <div class="flex flex-col">
                    <div class="flex flex-row p-2">
                      <p class="w-1/2 font-bold text-gray-700 dark:text-gray-400">Total</p>
                      <p class="w-1/2 font-normal text-gray-700 dark:text-gray-400">{{userDetails !== 'undefined' ? userDetails.credits.total : 0}}</p>
                    </div>

                    <div class="flex flex-row p-2">
                        <p class="w-1/2 font-bold text-gray-700 dark:text-gray-400">Remaining</p>
                        <p class="w-1/2 font-normal text-gray-700 dark:text-gray-400">{{userDetails.credits.remaining}}</p>
                    </div>
                  </div>
              </div>
            </div>
            <div class="md:h-full md:w-full pl-2 pr-2 mb-4">
              <div class="flex flex-col">
                  <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
                          <div class="overflow-hidden shadow-md sm:rounded-lg">
                              <table class="min-w-full">
                                  <thead class="bg-gray-50 dark:bg-gray-700">
                                      <tr>
                                          <th v-for="(creditDetailHeader,index) in creditDetailHeaders" :key="index" scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                              {{creditDetailHeader.text}}
                                          </th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for="(item,index) in userDetails.credits.credits_details.data" :key="index"  class="text-left bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                          <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                              {{item.type}}
                                          </td>
                                          <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                              {{item.total}}
                                          </td>
                                          <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                              {{item.remaining}}
                                          </td>
                                          <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                              <span v-if="item.ends_at === null">Forever</span>
                                              <span v-else>{{ item.ends_at + ' GMT+0000' | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY')}}</span>
                                          </td>
                                          <td class="flex space-x-2 py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                              <span v-if="item.remaining > 0" class="inline-flex items-center justify-center cursor-pointer px-2 py-1 text-xs font-semibold leading-none text-white bg-red-500 rounded-lg">
                                                Active
                                              </span>
                                              <span v-else class="inline-flex items-center justify-center cursor-pointer px-2 py-1 text-xs font-semibold leading-none text-white bg-gray-500 rounded-lg">
                                                Finished
                                              </span>
                                               <v-tooltip v-if="item.canceled_at" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                  <span
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="inline-flex items-center justify-center cursor-pointer px-2 py-1 text-xs font-semibold leading-none text-white bg-blue-400 rounded-lg"
                                                  >
                                                    Canceled - Usable
                                                  </span>
                                                </template>
                                                <div>
                                                  <span class="block text-center text-xs md:text-sm font-bold tracking-tight text-white dark:text-white">
                                                    <strong>Subscription Canceled At: </strong> {{ item.canceled_at + ' GMT+0000' | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY, h:mm:ss a')}}
                                                  </span>
                                                </div>
                                              </v-tooltip>
                                              
                                              <v-tooltip v-if="isToday(item.created_at)" color="red" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                  <span
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="inline-flex items-center justify-center cursor-pointer px-2 py-1 text-xs font-semibold leading-none text-white bg-red-500 rounded-lg"
                                                  >
                                                    New
                                                  </span>
                                                </template>
                                                <div>
                                                  <span class="block text-center text-xs md:text-sm font-bold tracking-tight text-white dark:text-white">
                                                    <strong>Subscription Credits Added At: </strong> {{ item.created_at + ' GMT+0000' | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY, h:mm:ss a')}}
                                                  </span>
                                                </div>
                                              </v-tooltip>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>

              <nav aria-label="Page navigation">
                <ul class="inline-flex -space-x-px">
                  <li v-if="userDetails.credits.credits_details.current_page !== 1">
                    <a @click="getProfileDetails(userDetails.credits.credits_details.current_page-1)" class="py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Previous</a>
                  </li>
                  <li v-for="index in userDetails.credits.credits_details.last_page" :key="index">
                    <a v-if="index === userDetails.credits.credits_details.current_page" @click="getProfileDetails(index)" aria-current="page" class="py-2 px-3 text-blue-600 bg-blue-50 border border-gray-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white">{{index}}</a>
                    <a v-else @click="getProfileDetails(index)" class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">{{index}}</a>
                  </li>
                  <li v-if="userDetails.credits.credits_details.current_page !== userDetails.credits.credits_details.last_page">
                    <a @click="getProfileDetails(userDetails.credits.credits_details.current_page+1)" class="py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Next</a>
                  </li>
                </ul>
              </nav>
            </div>
        </div>
        <div class="p-4 bg-white rounded-lg dark:bg-gray-800" :class="selectedTab === 2 ? '' : 'hidden'" id="settings" role="tabpanel" aria-labelledby="settings-tab">
            <div class="md:h-full md:w-full pl-2 pr-2 mb-4">
              <div v-if="creditUsageDetails.total > 0">
                <div class="flex flex-col">
                    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
                            <div class="overflow-hidden shadow-md sm:rounded-lg">
                                <table class="min-w-full">
                                    <thead class="bg-gray-50 dark:bg-gray-700">
                                        <tr>
                                            <th v-for="(creditUsageHeader,index) in creditUsageHeaders" :key="index" scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                {{creditUsageHeader.text}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in creditUsageDetails.data" :key="index"  class="text-left bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                            <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {{item.product_name}}
                                            </td>
                                            <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                                {{item.usage_amount}}
                                            </td>
                                            <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                                {{item.type}}
                                            </td>
                                            <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                                {{item.usage_time + ' GMT+0000' | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY, h:mm:ss a')}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <nav aria-label="Page navigation">
                  <ul class="inline-flex -space-x-px">
                    <li v-if="creditUsageDetails.current_page !== 1">
                      <a @click="getCreditUsageDetails(creditUsageDetails.current_page-1)" class="py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Previous</a>
                    </li>
                    <li v-for="index in creditUsageDetails.last_page" :key="index">
                      <a v-if="index === creditUsageDetails.current_page" @click="getCreditUsageDetails(index)" aria-current="page" class="py-2 px-3 text-blue-600 bg-blue-50 border border-gray-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white">{{index}}</a>
                      <a v-else @click="getCreditUsageDetails(index)" class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">{{index}}</a>
                    </li>
                    <li v-if="creditUsageDetails.current_page !== creditUsageDetails.last_page">
                      <a @click="getCreditUsageDetails(creditUsageDetails.current_page+1)" class="py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Next</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div v-else >
                <h5 class="m-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">No credit usage yet.</h5>
              </div>
            </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import CreditService from '../../services/credit.service';

  export default {
    name: 'CreditDetails',

    components: {
      
    },

    data(){
      return {
        userDetails: [],
        creditUsageDetails: [],
        creditDetailHeaders: [
          { text: 'Credit Source', value: 'type' },
          { text: 'Total', value: 'total' },
          { text: 'Remaining', value: 'remaining' },
          { text: 'Available Until', value: 'ends_at' },
          { text: 'Status', value: '' },
        ],
        creditUsageHeaders: [
          { text: 'Product Name', value: 'product_name' },
          { text: 'Credit Amount', value: 'usage_amount' },
          { text: 'Credit Source', value: 'type' },
          { text: 'Usage Time', value: 'usage_time' },
        ],
        selectedTab: 1
      }
    },

    created(){
      this.base = 'http://localhost:8000';
      
      this.init();
    },

    methods: {
      init(){
        this.loadFromStorage();
        this.getProfileDetails(1);
        this.getCreditUsageDetails(1);
      },

      loadFromStorage() {
        try {
          this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
        } catch(e) {
          localStorage.removeItem('userDetails');
        }
      },

      getProfileDetails(userCreditDetailsPage){
        CreditService.getUserCreditDetails(userCreditDetailsPage).then(
          response => {
            this.userDetails = response.data.response;

            this.userDetailsList = JSON.stringify(this.userDetails);
            localStorage.setItem('userDetails', this.userDetailsList);
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
        },

      getCreditUsageDetails(userCreditUsageDetailsPage){
          CreditService.getUserCreditUsageDetails(userCreditUsageDetailsPage)
              .then( function( response ){
                  this.creditUsageDetails = response.data.response.credit_usage_details;
              }.bind(this));
      },

      isToday(date) {
        return this.$moment(new Date()).format('DD-MM-YYYY') == this.$moment(date).format('DD-MM-YYYY');
      },
    }
  }
</script>